import { type CSSObject } from '@emotion/react'
import { CornerRadius, LineWeight, Spacing, Typography } from '@opallabs/gem'
import { cssTokenVariables } from '../styles'

export const labelToken = {
  ...Typography.T300,
  alignItems: 'center',
  backgroundColor: `var(${cssTokenVariables.colorBackground})`,
  border: `var(${cssTokenVariables.tokenBorder})`,
  borderRadius: CornerRadius.Small,
  color: `var(${cssTokenVariables.colorForeground})`,
  display: 'block',
  inlineSize: 'fit-content',
  lineHeight: `calc(var(${cssTokenVariables.tokenLabelHeight}) - ${LineWeight.Small} * 2px)`,
  maxInlineSize: 'inherit',
  overflow: 'hidden',
  paddingInline: Spacing.S,
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',

  '&:hover': {
    border: `var(${cssTokenVariables.tokenHoverBorder})`,
  },
} as const satisfies CSSObject
